const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0xa265aD7157BF93a32202d7B4b920dA3BAcB7aE71',
  busdAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
  lpAddress: '0x59dDA2cb90418ac8a54b932aC478513A20bB09C5'
}

export default priceContracts